module.exports = __webpack_public_path__ + "img/icon_blank_praise.670e0b56.png";